export default __webpack_public_path__ + "static/media/gloss.4b72fed3.svg";